import React from "react";
import {
  Segment,
  Grid,
  Header,
  Checkbox,
  Label,
  Icon
} from "semantic-ui-react";
import Flagship from "../../core/flagship";

class FilterAssignee extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      activeCategory: false,
      activeSubOptions: [],
      allUsers: {}
    };
    this.setActiveCategory = this.setActiveCategory.bind(this);
    this.setSubOptions = this.setSubOptions.bind(this);
    this.selectGroup = this.selectGroup.bind(this);
    this.deselectGroup = this.deselectGroup.bind(this);
    this.isActiveCategory = this.isActiveCategory.bind(this);
    this.countItems = this.countItems.bind(this);
    this.getActiveCategoryUsers = this.getActiveCategoryUsers.bind(this);
    this.flattenAllUsers = this.flattenAllUsers.bind(this);
  }

  componentDidMount() {
    let self = this;

    Flagship.get(
      "users/assignable",
      {},
      function(response) {
        if (response.data.success === true) {
          let allUsers = [];

          response.data.results.map(user => {
            let groups = user.user_group.split(",");
            groups.map(group => {
              if (typeof allUsers[group] !== "undefined") {
                allUsers[group].push(user);
              } else {
                allUsers[group] = [user];
              }
            });
          });
          self.setState({
            allUsers
          });
        } else {
          Flagship.error("Could not retrieve users for filter.", 0, 0);
        }
      },
      function(err) {
        Flagship.error(
          "An error occurred when querying users for filter: " + err,
          0,
          0
        );
      }
    );
  }

  isActiveCategory(category) {
    return this.state.activeCategory === category;
  }

  setActiveCategory(activeCategory, selectAll = false, selectNone = false) {
    this.setState({
      activeCategory
    });

    if (
      activeCategory === "unassigned" &&
      (selectAll === true || selectNone === true)
    ) {
      this.props.onToggle("assignee", "unassigned");
    }

    if (
      typeof this.state.allUsers[activeCategory] !== "undefined" &&
      this.state.allUsers[activeCategory].length
    ) {
      this.setSubOptions(
        this.state.allUsers[activeCategory],
        selectAll,
        selectNone
      );
    }
  }

  setSubOptions(activeSubOptions, selectAll = false, selectNone = false) {
    let self = this;
    this.setState(
      {
        activeSubOptions
      },
      () => {
        if (selectAll === true) {
          self.selectGroup();
        } else if (selectNone === true) {
          self.deselectGroup();
        }
      }
    );
  }

  flattenAllUsers() {
    let flat = [];
    let allUsers = this.state.allUsers;
    if (Object.keys(allUsers).length) {
      Object.keys(allUsers).map(category => {
        if (allUsers[category].length) {
          allUsers[category].map(user => {
            flat.push(user);
          });
        }
      });
    }
    return flat;
  }

  countItems(category) {
    let self = this;
    let count = 0;

    if (category === "unassigned") {
      if (this.props.active.includes("unassigned")) {
        return 1;
      } else {
        return 0;
      }
    }

    if (
      typeof this.state.allUsers[category] !== "undefined" &&
      this.state.allUsers[category].length
    ) {
      this.state.allUsers[category].map(user => {
        if (self.props.active.includes(user.id)) {
          count++;
        }
      });
    }
    return count;
  }

  categoryCount(category) {
    let self = this;
    if (self.props.active && category.length) {
      let count = this.countItems(category);
      if (count > 0)
        return (
          <Label
            circular
            className="selected-filter-count"
            color="pink"
            onClick={() => self.setActiveCategory(category, false, true)}
          >
            {count}
          </Label>
        );
    }

    // Unselected Group
    return (
      <Label
        circular
        className="selected-filter-count"
        onClick={() => self.setActiveCategory(category, true, false)}
      >
        -
      </Label>
    );
  }

  selectGroup() {
    let newSelection;
    if (typeof this.props.active === "undefined") {
      newSelection = this.getIdsOnly(this.state.activeSubOptions);
    } else {
      newSelection = [
        ...this.props.active,
        ...this.getIdsOnly(this.state.activeSubOptions)
      ];
    }
    this.props.onSelectMultiple("assignee", newSelection);
  }

  deselectGroup() {
    let toRemove = this.getIdsOnly(this.state.activeSubOptions);
    let oldSelection;
    if (typeof this.props.active === "undefined") {
      oldSelection = [];
    } else {
      oldSelection = [...this.props.active];
    }

    let newSelection = [];

    if (oldSelection.length) {
      oldSelection.map(item => {
        if (!toRemove.includes(item)) {
          newSelection.push(item);
        }
      });
    }

    this.props.onSelectMultiple("assignee", newSelection);
  }

  getActiveCategoryUsers() {
    return this.state.allUsers[this.state.activeCategory];
  }

  getIdsOnly(dataset) {
    let ids = [];
    if (!Array.isArray(dataset)) return false;
    dataset.map(user => {
      ids.push(user.id);
    });
    return ids;
  }

  render() {
    let self = this;

    return (
      <div>
        {this.props.expanded ? (
          <Segment className="filter-section-expanded">
            <Header as="h4" style={{ marginBottom: ".1em" }}>
              Assignee
            </Header>
            <div className="filter-meta" style={{ marginBottom: ".5em" }}>
              <small
                className="gray-text"
                onClick={() =>
                  self.props.onSelectMultiple(
                    "assignee",
                    this.getIdsOnly(this.flattenAllUsers(this.state.allUsers))
                  )
                }
              >
                Select All
              </small>
              <span> | </span>
              <small
                className="gray-text"
                onClick={() => self.props.onSelectMultiple("assignee", [])}
              >
                Select None
              </small>
            </div>
            <Grid stackable columns={2} style={{ marginTop: ".75em" }}>
              <Grid.Column>
                <strong>Categories</strong>
                <div className="filter-controls" style={{ marginTop: ".25em" }}>
                  {this.props.possible.map((category, i) => {
                    return (
                      <div
                        key={"category" + i}
                        onClick={() => {
                          this.setActiveCategory(category);
                        }}
                        className={
                          self.isActiveCategory(category)
                            ? "filter-category active"
                            : "filter-category"
                        }
                      >
                        {self.categoryCount(category)}
                        {category}
                      </div>
                    );
                  })}
                </div>
                <div
                  key={"category-unassigned"}
                  onClick={() => {
                    this.setActiveCategory("unassigned");
                  }}
                  className={
                    self.isActiveCategory("unassigned")
                      ? "filter-category active"
                      : "filter-category"
                  }
                >
                  {self.categoryCount("unassigned")}
                  <em>Unassigned</em>
                </div>
              </Grid.Column>
              <Grid.Column>
                <strong>Selected Users</strong>
                {typeof this.state.activeCategory !== "undefined" &&
                this.state.activeCategory !== false ? (
                  <div
                    className="filter-meta"
                    style={{ marginBottom: ".5em", marginTop: ".25em" }}
                  >
                    <small className="gray-text" onClick={self.selectGroup}>
                      Select All
                    </small>
                    <span> | </span>
                    <small className="gray-text" onClick={self.deselectGroup}>
                      Select None
                    </small>
                  </div>
                ) : (
                  <div
                    className="filter-meta"
                    style={{ marginBottom: ".5em", marginTop: ".25em" }}
                  >
                    <small className="gray-text">
                      Choose a category first.
                    </small>
                  </div>
                )}
                {this.state.activeCategory === "unassigned" ? (
                  <div style={{ padding: ".1em 0" }} key="unassigned">
                    <Checkbox
                      checked={
                        self.props.active &&
                        self.props.active.includes("unassigned")
                      }
                      onChange={() => {
                        self.props.onToggle("assignee", "unassigned");
                      }}
                      style={{
                        marginBottom: "0",
                        marginTop: ".75em",
                        marginRight: ".25em",
                        height: "30px",
                        verticalAlign: "middle"
                      }}
                    />
                    <Label
                      onClick={() => {
                        self.props.onToggle("assignee", "unassigned");
                      }}
                      style={{
                        height: "30px",
                        verticalAlign: "middle",
                        cursor: "pointer"
                      }}
                    >
                      <em>Unassigned</em>
                    </Label>
                  </div>
                ) : null}
                {typeof this.state.allUsers[this.state.activeCategory] !==
                  "undefined" &&
                  typeof this.state.allUsers[this.state.activeCategory].map ===
                    "function" &&
                  this.state.allUsers[this.state.activeCategory].map(
                    (user, i) => {
                      return (
                        <div style={{ padding: ".1em 0" }} key={i}>
                          <Checkbox
                            checked={
                              self.props.active &&
                              self.props.active.includes(user.id)
                            }
                            onChange={() => {
                              self.props.onToggle("assignee", user.id);
                            }}
                            style={{
                              marginBottom: "0",
                              marginTop: ".75em",
                              marginRight: ".25em",
                              height: "30px",
                              verticalAlign: "middle"
                            }}
                          />
                          <Label
                            onClick={() => {
                              self.props.onToggle("assignee", user.id);
                            }}
                            style={{
                              height: "30px",
                              verticalAlign: "middle",
                              cursor: "pointer"
                            }}
                          >
                            {user.first_name} {user.last_name}
                          </Label>
                        </div>
                      );
                    }
                  )}
              </Grid.Column>
            </Grid>
          </Segment>
        ) : (
          <Segment
            className="filter-section-collapsed"
            onClick={() => this.props.setExpanded(true)}
          >
            <Icon
              name="angle double right"
              size="big"
              style={{ float: "right" }}
            />
            <Header as="h4" style={{ margin: ".1em 0" }}>
              Assignee
            </Header>
            {typeof this.props.active !== "undefined" &&
            this.props.active.length ? (
              <Label color="pink">
                {this.props.active.length} Active Filter
                {this.props.active.length !== 1 ? "s" : null}
              </Label>
            ) : (
              <small>Click to filter...</small>
            )}
          </Segment>
        )}
      </div>
    );
  }
}

export default FilterAssignee;



// WEBPACK FOOTER //
// ./src/components/misc/FilterAssignee.js